import Layout from '@/layout';
import Content from '@/layout/content';
import ctt from '@/utils/const/index';

import { isEmpty } from '@/utils/is';
import { getDeviceTrackPath, routeList } from '../utils/deviceTrack';

export default {
  path: '/devices',
  component: window.name ? Content : Layout,
  redirect: { name: 'deviceMonitor' },
  meta: {
    title: '设备监控',
    icon: 'iconfont icon-shexiangtou',
    // codes: ['010202', '010214']
    code: '010202'
  },
  children: [
    {
      name: 'DeviceTrack',
      path: 'track',
      component: () => import('@/views/deviceTrack/index.vue'),
      redirect: to => {
        const { params } = to;
        const name = getDeviceTrackPath(params);

        if (isEmpty(name)) {
          return '404';
        }

        return { name, params };
      },
      children: routeList
    },
    {
      name: 'deviceMonitor',
      path: 'monitor',
      component: () => import('@/views/deviceMonitor'),
      meta: {
        activeMenu: '/devices',
        noPadding: true
      },
      children: [
        {
          path: 'home',
          name: 'deviceHome',
          component: () => import('@/views/deviceMonitor/HomePage'),
          meta: {
            activeMenu: '/devices',
            hidden: true,
            noPadding: true
          }
        },
        {
          path: 'map',
          name: 'deviceMap',
          component: () => import('@/views/deviceMonitor/Map/index.vue'),
          meta: {
            activeMenu: '/devices',
            hidden: true,
            noPadding: true
          }
        },
        {
          path: 'map2',
          name: 'deviceMap2',
          component: () => import('@/views/deviceMonitor/BMap'),
          meta: {
            activeMenu: '/devices',
            hidden: true,
            noPadding: true
          }
        },
        {
          path: 'scene',
          name: 'deviceScene',
          component: () => import('@/views/deviceMonitor/Scene'),
          meta: {
            activeMenu: '/devices',
            hidden: true,
            noPadding: true
          }
        },
        {
          path: 'list',
          name: 'deviceList',
          component: () => import('@/views/deviceMonitor/List'),
          meta: {
            activeMenu: '/devices',
            hidden: true,
            noPadding: true
          }
        },
        {
          path: 'alarm',
          name: 'deviceAlarm',
          component: () => import('@/views/deviceMonitor/ALarm'),
          meta: {
            activeMenu: '/devices',
            hidden: true,
            noPadding: true
          }
        }
      ]
    },
    {
      path: 'gd606/:sn?/:eventId?/:deviceType',
      name: 'GD606',
      component: () => import('@/views/realdata/GD606'),
      props: true,
      meta: {
        key: true,
        activeMenu: '/devices',
        headerOptions: {
          name: true,
          img: 'static/image/main_header.png',
          menu: 'gd606'
        }
      }
    },
    {
      path: 'gd624/:sn?/:eventId?/:deviceType',
      name: 'GD624',
      component: () => import('@/views/realdata/GD624'),
      props: true,
      meta: {
        key: true,
        activeMenu: '/devices',
        headerOptions: {
          name: true,
          img: 'static/image/main_header.png',
          menu: 'gd624'
        }
      }
    },
    {
      path: 'mn606/:sn?/:eventId?/:deviceType',
      name: 'MN606',
      component: () => import('@/views/realdata/MN606'),
      props: true,
      meta: {
        key: true,
        activeMenu: '/devices',
        headerOptions: {
          name: true,
          img: 'static/image/main_header.png',
          menu: 'mn606'
        }
      }
    },
    {
      path: 'gd612/:sn?/:eventId?/:deviceType',
      name: 'GD612',
      component: () => import('@/views/realdata/GD612'),
      props: true,
      meta: {
        key: true,
        activeMenu: '/devices',
        headerOptions: {
          name: true,
          img: 'static/image/main_header.png',
          menu: 'gd612'
        }
      }
    },
    {
      path: 'gm602/:sn?/:eventId?/:deviceType',
      name: 'GM602',
      component: () => import('@/views/realdata/GM602'),
      props: true,
      meta: {
        key: true,
        activeMenu: '/devices',
        headerOptions: {
          name: true,
          img: 'static/image/main_header.png',
          menu: 'gm602'
        }
      }
    },
    {
      path: 'gm606/:sn?/:eventId?/:deviceType',
      name: 'GM606',
      component: () => import('@/views/realdata/GM606'),
      props: true,
      meta: {
        key: true,
        activeMenu: '/devices',
        headerOptions: {
          name: true,
          img: 'static/image/main_header.png',
          menu: 'gm606'
        }
      }
    },
    {
      path: 'wireless-box/:sn?/:eventId?/:deviceType',
      name: 'wireless-box',
      component: () => import('@/views/realdata/wireless-box'),
      props: true,
      meta: {
        key: true,
        activeMenu: '/devices',
        headerOptions: {
          name: true,
          img: 'static/image/main_header.png'
          //   menu: 'wireless-box'
        }
      }
    },
    {
      path: 'cd603/:sn?/:eventId?/:deviceType',
      name: 'CD603',
      component: () => import('@/views/realdata/CD603'),
      props: true,
      meta: {
        key: true,
        activeMenu: '/devices',
        headerOptions: {
          name: true,
          img: 'static/image/main_header.png',
          menu: 'cd603'
        }
      }
    },
    {
      path: 'cd602/:sn?/:eventId?/:deviceType',
      name: 'CD602',
      component: () => import('@/views/realdata/CD602/index.vue'),
      props: true,
      meta: {
        key: true,
        activeMenu: '/devices',
        headerOptions: {
          name: true,
          img: 'static/image/main_header.png',
          menu: 'cd602'
        }
      }
    },
    {
      path: 'fcbr100/:sn?/:eventId?/:deviceType',
      name: 'FCBR100',
      component: () => import('@/views/realdata/FCBR-100'),
      props: true,
      meta: {
        key: true,
        activeMenu: '/devices',
        headerOptions: {
          name: true,
          img: 'static/image/main_header.png',
          menu: 'fcbr100'
        }
      }
    },
    {
      path: 'fcbr100pro/:sn?/:eventId?/:deviceType',
      name: 'FCBR100Pro',
      component: () => import('@/views/realdata/FCBR-100'),
      props: true,
      meta: {
        key: true,
        activeMenu: '/devices',
        headerOptions: {
          name: true,
          img: 'static/image/main_header.png',
          menu: 'fcbr100pro',
          weather: true
        }
      }
    },
    {
      path: 'fcbr100cfr/:sn?/:eventId?/:deviceType',
      name: 'FCBR100CFR',
      component: () => import('@/views/realdata/FCBR-100CFR'),
      props: true,
      meta: {
        key: true,
        activeMenu: '/devices',
        headerOptions: {
          name: true,
          img: 'static/image/main_header.png',
          menu: 'fcbr100cfr',
          ['pm2.5']: true
        }
      }
    },
    {
      path: 'fcbr100b/:sn?/:eventId?/:deviceType',
      name: 'FCBR100b',
      component: () => import('@/views/realdata/FCBR-100'),
      props: true,
      meta: {
        key: true,
        activeMenu: '/devices',
        headerOptions: {
          name: true,
          img: 'static/image/main_header.png',
          menu: 'fcbr100b'
        }
      }
    },
    {
      path: 'fcbr100f/:sn?/:eventId?/:deviceType',
      name: 'FCBR100f',
      component: () => import('@/views/realdata/FCBR-100'),
      props: true,
      meta: {
        key: true,
        activeMenu: '/devices',
        headerOptions: {
          name: true,
          img: 'static/image/main_header.png',
          menu: 'fcbr100f'
        }
      }
    },
    {
      path: 'fcbr100c/:sn?/:eventId?/:deviceType',
      name: 'FCBR100C',
      component: () => import('@/views/realdata/FCBR-100'),
      props: true,
      meta: {
        key: true,
        activeMenu: '/devices',
        headerOptions: {
          name: true,
          img: 'static/image/main_header.png',
          menu: 'fcbr100c'
        }
      }
    },
    {
      path: 'fcbr100cv2/:sn?/:eventId?/:deviceType',
      name: 'FCBR100CV2',
      component: () => import('@/views/realdata/FCBR-100'),
      props: true,
      meta: {
        key: true,
        activeMenu: '/devices',
        headerOptions: {
          name: true,
          img: 'static/image/main_header.png',
          menu: 'fcbr100cv2'
        }
      }
    },
    {
      path: 'fcbr100m/:sn?/:eventId?/:deviceType',
      name: 'FCBR100M',
      component: () => import('@/views/realdata/FCBR-100M'),
      props: true,
      meta: {
        key: true,
        activeMenu: '/devices',
        code: '010423',
        headerOptions: {
          name: true,
          img: 'static/image/main_header.png',
          menu: 'fcbr100m',
          humidity: true,
          temperature: true
        }
      }
    },
    {
      path: 'fcbr100n/:sn?/:eventId?/:deviceType',
      name: 'FCBR100N',
      component: () => import('@/views/realdata/FCBR-100N'),
      props: true,
      meta: {
        key: true,
        activeMenu: '/devices',
        // code: '010423',
        headerOptions: {
          name: true,
          img: 'static/image/main_header.png',
          menu: 'fcbr100n',
          humidity: true,
          temperature: true
        }
      }
    },
    {
      path: 'fcbr100cp/:sn?/:eventId?/:deviceType',
      name: 'FCBR100CP',
      component: () => import('@/views/realdata/FCBR-100'),
      props: true,
      meta: {
        key: true,
        activeMenu: '/devices',
        headerOptions: {
          name: true,
          img: 'static/image/main_header.png',
          menu: 'fcbr100cp',
          weather: true,
          o2: true
        }
      }
    },
    {
      path: 'fcbr100proga/:sn?/:eventId?/:deviceType',
      name: 'FCBR100ProGA',
      component: () => import('@/views/realdata/FCBR-100'),
      props: true,
      meta: {
        key: true,
        activeMenu: '/devices',
        headerOptions: {
          name: true,
          img: 'static/image/main_header.png',
          menu: 'fcbr100proga',
          weather: true
        }
      }
    },
    {
      path: 'fcbr100ga/:sn?/:eventId?/:deviceType',
      name: 'FCBR100GA',
      component: () => import('@/views/realdata/FCBR-100'),
      props: true,
      meta: {
        key: true,
        activeMenu: '/devices',
        headerOptions: {
          name: true,
          img: 'static/image/main_header.png',
          menu: 'fcbr100ga',
          weather: true
        }
      }
    },
    {
      path: 'cr2500/:sn?/:eventId?/:deviceType',
      name: 'CR2500',
      component: () => import('@/views/realdata/CR2500'),
      props: true,
      meta: {
        key: true,
        activeMenu: '/devices',
        headerOptions: {
          name: true,
          img: 'static/image/main_header.png',
          menu: 'CR'
        }
      }
    },
    {
      path: 'BM4000/:sn?/:eventId?/:deviceType',
      name: 'BM4000',
      component: () => import('@/views/realdata/BM4000'),
      props: true,
      meta: {
        key: true,
        activeMenu: '/devices',
        headerOptions: {
          name: true,
          img: 'static/image/main_header.png',
          menu: 'BM4000'
        }
      }
    },
    {
      path: 'CB12231/:sn?/:eventId?/:deviceType',
      name: 'CB12231',
      component: () => import('@/views/realdata/CB12231'),
      props: true,
      meta: {
        key: true,
        activeMenu: '/devices',
        headerOptions: {
          name: true,
          img: 'static/image/main_header.png',
          menu: 'CB12231'
        }
      }
    },
    {
      path: 'fcbr100s1/:sn?/:eventId?/:deviceType',
      name: 'FCBR100S1',
      component: () => import('@/views/realdata/FCBR-100S1'),
      props: true,
      meta: {
        key: true,
        activeMenu: '/devices',
        code: '010420',
        headerOptions: {
          name: true,
          img: 'static/image/main_header.png',
          menu: 'fcbr100s1'
        }
      }
    },
    {
      path: 'chemPro100/:sn?/:eventId?/:deviceType',
      name: 'ChemPro100',
      component: () => import('@/views/realdata/FCBR-100S1'),
      props: true,
      meta: {
        key: true,
        activeMenu: '/devices',
        headerOptions: {
          name: true,
          img: 'static/image/main_header.png',
          menu: 'chemPro100'
        }
      }
    },
    {
      path: 'ht01/:sn?/:eventId?/:deviceType',
      name: 'HT01',
      component: () => import('@/views/realdata/HT01'),
      props: true,
      meta: {
        key: true,
        activeMenu: '/devices',
        headerOptions: {
          name: true,
          img: 'static/image/main_header.png'
        }
      }
    },
    {
      path: 'ht100/:sn?/:eventId?/:deviceType',
      name: 'HT100',
      component: () => import('@/views/realdata/HT100/index.vue'),
      props: true,
      meta: {
        key: true,
        activeMenu: '/devices',
        headerOptions: {
          name: true,
          img: 'static/image/main_header.png'
        }
      }
    },
    {
      path: 'ht200/:sn?/:eventId?/:deviceType',
      name: 'HT200',
      component: () => import('@/views/realdata/HT200/index.vue'),
      props: true,
      meta: {
        key: true,
        activeMenu: '/devices',
        headerOptions: {
          name: true,
          img: 'static/image/main_header.png',
          menu: 'ht200'
        }
      }
    },
    {
      path: 'ht300/:sn?/:eventId?/:deviceType',
      name: 'HT300',
      component: () => import('@/views/realdata/HT300/index.vue'),
      props: true,
      meta: {
        key: true,
        activeMenu: '/devices',
        headerOptions: {
          name: true,
          img: 'static/image/main_header.png',
          menu: 'ht300'
        }
      }
    },
    {
      path: 'ac200/:sn?/:eventId?/:deviceType',
      name: 'AC200',
      component: () => import('@/views/realdata/AC200'),
      props: true,
      meta: {
        key: true,
        activeMenu: '/devices',
        headerOptions: {
          name: true,
          img: 'static/image/main_header.png',
          menu: 'ac200'
        }
      }
    },
    {
      path: 'ac1000/:sn?/:eventId?/:deviceType',
      name: 'AC1000',
      component: () => import('@/views/realdata/AC1000'),
      props: true,
      meta: {
        key: true,
        activeMenu: '/devices',
        headerOptions: {
          name: true,
          img: 'static/image/main_header.png',
          menu: 'ac1000'
        }
      }
    },
    {
      path: 'bc500/:sn?/:eventId?/:deviceType',
      name: 'BC500',
      component: () => import('@/views/realdata/BC500'),
      props: true,
      meta: {
        key: true,
        activeMenu: '/devices',
        headerOptions: {
          name: true,
          img: 'static/image/main_header.png',
          menu: 'bc500'
        }
      }
    },
    {
      path: 'chemProFXi/:sn?/:eventId?/:deviceType',
      name: 'ChemProFXi',
      component: () => import('@/views/realdata/HTDevice'),
      props: true,
      meta: {
        key: true,
        activeMenu: '/devices',
        headerOptions: {
          name: true,
          img: 'static/image/main_header.png',
          menu: 'chemProFXi'
        }
      }
    },
    {
      path: 'RG500/:sn?/:eventId?/:deviceType',
      name: 'RG500',
      component: () => import('@/views/realdata/RG500'),
      props: true,
      meta: {
        key: true,
        activeMenu: '/devices',
        headerOptions: {
          name: true,
          img: 'static/image/main_header.png',
          menu: 'rg500'
        }
      }
    },
    {
      path: 'RG05/:sn?/:eventId?/:deviceType',
      name: 'RG05',
      component: () => import('@/views/realdata/RG05'),
      props: true,
      meta: {
        key: true,
        activeMenu: '/devices',
        headerOptions: {
          name: true,
          img: 'static/image/main_header.png',
          menu: 'rg05'
        }
      }
    },
    {
      path: 'geminin/:sn?/:eventId?/:deviceType',
      name: 'GeminiN',
      component: () => import('@/views/realdata/GeminiN'),
      props: true,
      meta: {
        key: true,
        activeMenu: '/devices',
        bgImg: 'static/image/device-bg2.png',
        headerOptions: {
          img: 'static/image/header2.png',
          titleClass: 'header-text2',
          menu: 'geminiN'
        }
      }
    },
    {
      path: 'vp100/:sn?/:eventId?/:deviceType',
      name: 'VP100',
      component: () => import('@/views/realdata/VP100'),
      props: true,
      meta: {
        key: true,
        activeMenu: '/devices',
        bgImg: 'static/image/device-bg2.png',
        headerOptions: {
          img: 'static/image/header2.png',
          titleClass: 'header-text2',
          menu: 'vp100'
        }
      }
    },
    {
      path: 'vp200/:sn?/:eventId?/:deviceType',
      name: 'VP200',
      component: () => import('@/views/realdata/VP200'),
      props: true,
      meta: {
        key: true,
        activeMenu: '/devices',
        bgImg: 'static/image/device-bg2.png',
        headerOptions: {
          img: 'static/image/header2.png',
          titleClass: 'header-text2',
          menu: 'vp200'
        }
      }
    },
    {
      path: 'pidIndApp/:sn?/:eventId?/:deviceType',
      name: 'PidIndApp',
      component: () => import('@/views/realdata/PidIndApp'),
      props: true,
      meta: {
        key: true,
        activeMenu: '/devices',
        bgImg: 'static/image/device-bg2.png',
        headerOptions: {
          img: 'static/image/header2.png',
          titleClass: 'header-text2',
          menu: 'pidIndApp',
          name: true,
          state: true
        }
      }
    },
    {
      path: 'ngp2/:sn?/:eventId?/:deviceType',
      name: 'Ngp2',
      component: () => import('@/views/realdata/Ngp2/index2.vue'),
      props: true,
      meta: {
        key: true,
        activeMenu: '/devices',
        bgImg: 'static/image/device-bg2.png',
        headerOptions: {
          img: 'static/image/header2.png',
          titleClass: 'header-text2',
          menu: 'ngp2'
        }
      }
    },
    {
      path: 'rs500/:sn?/:eventId?/:deviceType',
      name: 'RS500',
      component: () => import('@/views/realdata/RS500/index2.vue'),
      props: true,
      meta: {
        key: true,
        activeMenu: '/devices',
        bgImg: 'static/image/device-bg2.png',
        headerOptions: {
          img: 'static/image/header2.png',
          titleClass: 'header-text2',
          menu: 'rs500'
        }
      }
    },
    {
      path: 'fitRM/:sn?/:eventId?/:deviceType',
      name: 'fitRM',
      component: () => import('@/views/realdata/fitRM'),
      props: true,
      meta: {
        key: true,
        activeMenu: '/devices',
        bgImg: 'static/image/device-bg2.png',
        headerOptions: {
          img: 'static/image/header2.png',
          titleClass: 'header-text2',
          menu: 'fitRM',
          name: true
        }
      }
    },
    {
      path: 'NRH-M01/:sn?/:eventId?/:deviceType',
      name: 'NRH-M01',
      component: () => import('@/views/realdata/NRH-M01'),
      props: true,
      meta: {
        key: true,
        activeMenu: '/devices',
        headerOptions: {
          name: true,
          img: 'static/image/main_header.png'
          //   menu: 'wireless-box'
        }
      }
    },
    {
      path: 'PMS6003/:sn?/:eventId?/:deviceType',
      name: 'PMS6003',
      component: () => import('@/views/realdata/PMS6003'),
      props: true,
      meta: {
        key: true,
        activeMenu: '/devices',
        headerOptions: {
          name: true,
          img: 'static/image/main_header.png'
          //   menu: 'wireless-box'
        }
      }
    },
    {
      path: 'PTQXZ/:sn?/:eventId?/:deviceType',
      name: 'PTQXZ',
      component: () => import('@/views/realdata/PTQXZ'),
      props: true,
      meta: {
        key: true,
        activeMenu: '/devices',
        headerOptions: {
          name: true,
          img: 'static/image/main_header.png'
          //   menu: 'PTQXZ'
        }
      }
    },
    {
      path: 'RFQF01/:sn?/:eventId?/:deviceType',
      name: 'RFQF01',
      component: () => import('@/views/realdata/RFQF01'),
      props: true,
      meta: {
        key: true,
        activeMenu: '/devices',
        headerOptions: {
          name: true,
          img: 'static/image/main_header.png'
          //   menu: 'wireless-box'
        }
      }
    },
    {
      path: 'CR1224/:sn?/:eventId?/:deviceType',
      name: 'CR1224',
      component: () => import('@/views/realdata/CR1224'),
      props: true,
      meta: {
        key: true,
        activeMenu: '/devices',
        headerOptions: {
          name: true,
          img: 'static/image/main_header.png'
          //   menu: 'wireless-box'
        }
      }
    },
    {
      path: 'CT1226/:sn?/:eventId?/:deviceType',
      name: 'CT1226',
      component: () => import('@/views/realdata/CT1226'),
      props: true,
      meta: {
        key: true,
        activeMenu: '/devices',
        headerOptions: {
          name: true,
          img: 'static/image/main_header.png',
          menu: 'CT1226'
        }
      }
    },
    {
      path: 'CR0534/:sn?/:eventId?/:deviceType',
      name: 'CR0534',
      component: () => import('@/views/realdata/CR0534'),
      props: true,
      meta: {
        key: true,
        activeMenu: '/devices',
        headerOptions: {
          name: true,
          img: 'static/image/main_header.png',
          menu: 'CR0534'
        }
      }
    },
    {
      path: 'CR05341/:sn?/:eventId?/:deviceType',
      name: 'CR05341',
      component: () => import('@/views/realdata/CR05341'),
      props: true,
      meta: {
        key: true,
        activeMenu: '/devices',
        headerOptions: {
          name: true,
          img: 'static/image/main_header.png',
          menu: 'CR05341'
        }
      }
    },
    {
      path: 'rms/:sn?/:eventId?/:deviceType',
      name: 'Rms',
      component: () => import('@/views/realdata/RMS'),
      props: true,
      meta: {
        key: true,
        activeMenu: '/devices',
        bgImg: 'static/image/device-bg2.png',
        headerOptions: {
          img: 'static/image/header2.png',
          titleClass: 'header-text2',
          menu: 'Rms'
          // name: true
        }
      }
    },
    {
      path: 'GW1021/:sn?/:eventId?/:deviceType',
      name: 'GW1021',
      component: () => import('@/views/realdata/GW1021'),
      props: true,
      meta: {
        key: true,
        activeMenu: '/devices',
        headerOptions: {
          name: true,
          img: 'static/image/main_header.png'
        }
      }
    },
    {
      path: 'GW1041/:sn?/:eventId?/:deviceType',
      name: 'GW1041',
      component: () => import('@/views/realdata/GW1041'),
      props: true,
      meta: {
        key: true,
        activeMenu: '/devices',
        headerOptions: {
          name: true,
          img: 'static/image/main_header.png'
        }
      }
    },
    {
      path: 'GW1034M/:sn?/:eventId?/:deviceType',
      name: 'GW1034M',
      component: () => import('@/views/realdata/GW1034M'),
      props: true,
      meta: {
        key: true,
        activeMenu: '/devices',
        headerOptions: {
          name: true,
          img: 'static/image/main_header.png'
        }
      }
    },
    {
      path: 'BU10/:sn?/:eventId?/:deviceType',
      name: 'BU10',
      component: () => import('@/views/realdata/BU10'),
      props: true,
      meta: {
        key: true,
        activeMenu: '/devices',
        headerOptions: {
          name: true,
          img: 'static/image/main_header.png'
        }
      }
    },
    {
      path: 'EFM100/:sn?/:eventId?/:deviceType',
      name: 'EFM100',
      component: () => import('@/views/realdata/EFM100'),
      props: true,
      meta: {
        key: true,
        activeMenu: '/devices',
        headerOptions: {
          name: true,
          img: 'static/image/main_header.png'
        }
      }
    },
    {
      path: 'RM1000/:sn?/:eventId?/:deviceType',
      name: 'RM1000',
      component: () => import('@/views/realdata/RM1000'),
      props: true,
      meta: {
        key: true,
        activeMenu: '/devices',
        headerOptions: {
          name: true,
          img: 'static/image/main_header.png',
          menu: 'rm1000'
        }
      }
    },

    {
      path: 'realdata/:sn?/:eventId?/:deviceType',
      name: 'Realdata',
      redirect: to => {
        const { sn, eventId, deviceType } = to.params;

        let params;
        let name;
        if (sn && eventId) {
          params = { sn, eventId, deviceType };
        } else if (sn) {
          params = { sn, deviceType };
        } else if (eventId) {
          params = { eventId, deviceType };
        }
        if (
          ctt.CR.split(',').includes(deviceType) ||
          ctt.EF.split(',').includes(deviceType) ||
          /^IF/.test(deviceType)
        ) {
          name = 'CR2500';
        } else {
          switch (deviceType) {
            case ctt.FCBR_100_v1:
            case ctt.FCBR_100_v2:
            case ctt.FCBR_100G:
              name = 'FCBR100';
              break;
            case ctt.FCBR_100PRO:
              name = 'FCBR100Pro';
              break;
            case ctt.FCBR_100CFR:
              name = 'FCBR100CFR';
              break;
            case ctt.FCBR_100PROGA:
              name = 'FCBR100ProGA';
              break;
            case ctt.FCBR_100GA:
              name = 'FCBR100GA';
              break;
            case ctt.FCBR_100F:
              name = 'FCBR100f';
              break;
            case ctt.FCBR_100CP:
              name = 'FCBR100CP';
              break;
            case ctt.FCBR_100C:
              name = 'FCBR100C';
              break;
            case ctt.FCBR_100CV2:
              name = 'FCBR100CV2';
              break;
            case ctt.FCBR_100M:
              name = 'FCBR100M';
              break;
            case ctt.FCBR100_N:
              name = 'FCBR100N';
              break;
            case ctt.FCBR_100B:
              name = 'FCBR100b';
              break;
            case ctt.BU_10:
              name = 'BU10';
              break;

            case ctt.J171:
            case ctt.CR2500:
              name = 'CR2500';
              break;
            case ctt.B02_V2:
              name = 'BM4000';
              break;
            case ctt.CB12231:
              name = 'CB12231';
              break;
            case ctt.FCBR_100S1:
              name = 'FCBR100S1';
              break;
            case ctt.Chem_Pro_100:
              name = 'ChemPro100';
              break;
            case ctt.Chem_Pro_FXi:
              name = 'ChemProFXi';
              break;
            case ctt.RG_500:
              name = 'RG500';
              break;
            case ctt.RG_05:
              name = 'RG05';
              break;
            case ctt.NGP_2:
              name = 'Ngp2';
              break;
            case ctt.VP_100:
              name = 'VP100';
              break;
            case ctt.VP_200:
              name = 'VP200';
              break;
            case ctt.PID_IndApp:
              name = 'PidIndApp';
              break;
            case ctt.Gemini_N:
              name = 'GeminiN';
              break;
            case ctt.RS_500:
              name = 'RS500';
              break;
            case ctt.FIT_RM:
              name = 'fitRM';
              break;
            case ctt.CIAE_RMS_E:
            case ctt.CIAE_RMS_C:
              name = 'Rms';
              break;
            case ctt.CD_603:
              name = 'CD603';
              break;
            case ctt.CD_602:
              name = 'CD602';
              break;
            case ctt.GD_611:
            case ctt.GD_606:
              name = 'GD606';
              break;
            case ctt.GD_624:
              name = 'GD624';
              break;
            case ctt.MN_606:
              name = 'MN606';
              break;
            case ctt.GD_612:
              name = 'GD612';
              break;
            case ctt.GM_602:
              name = 'GM602';
              break;
            case ctt.GM_606:
              name = 'GM606';
              break;
            case ctt.HT01:
              name = 'HT01';
              break;
            case ctt.HT100:
              name = 'HT100';
              break;
            case ctt.HT200:
              name = 'HT200';
              break;
            case ctt.HT300:
              name = 'HT300';
              break;
            case ctt.AC200:
              name = 'AC200';
              break;
            case ctt.AC1000:
              name = 'AC1000';
              break;
            case ctt.BC500:
              name = 'BC500';
              break;
            case ctt.WIRELESSBOX:
              name = 'wireless-box';
              break;
            case ctt.NRHM01:
              name = 'NRH-M01';
              break;
            case ctt.PMS6003:
              name = 'PMS6003';
              break;
            case ctt.RFQF01:
              name = 'RFQF01';
              break;
            case ctt.CR1224:
              name = 'CR1224';
              break;
            case ctt.CT1226:
              name = 'CT1226';
              break;
            case ctt.CB1223:
              name = 'BM4000';
              break;

            case ctt.CR0534:
              name = 'CR0534';
              break;

            case ctt.CR05341:
              name = 'CR05341';
              break;

            case ctt.PTQXZ:
              name = 'PTQXZ';
              break;
            case ctt.GW1021:
              name = 'GW1021';
              break;
            case ctt.GW1034M:
              name = 'GW1034M';
              break;
            case ctt.GW1041:
              name = 'GW1041';
              break;
            case ctt.EFM100:
              name = 'EFM100';
              break;
            case ctt.RM1000:
              name = 'RM1000';
              break;
            default:
              return { name: 'Page404' };
          }
        }
        return { name, params };
      }
    },
    {
      path: 'fcbr100bExpert/:sn/:deviceType',
      name: 'FCBR100bExpert',
      component: () => import('@/views/expert/FCBR-100B'),
      props: true,
      meta: {
        noPadding: true,
        activeMenu: '/devices'
      }
    },
    {
      path: 'expert/:sn/:deviceType',
      name: 'Expert',
      redirect: to => {
        const { deviceType } = to.params;
        if (deviceType === ctt.FCBR_100_v1 || deviceType === ctt.FCBR_100_v2) {
          return { name: 'FCBR100Expert', params: to.params };
        } else if (deviceType === ctt.FCBR_100PRO) {
          return { name: 'FCBR100proExpert', params: to.params };
        } else if (deviceType === ctt.FCBR_100B || deviceType === ctt.B02_V1) {
          return { name: 'FCBR100bExpert', params: to.params };
        } else if (deviceType === ctt.CR2500) {
          return { name: 'CR2500Expert', params: to.params };
        }
      }
    },
    {
      path: 'muldevices/:deviceType',
      name: 'MulDevices',
      component: () => import('@/views/mulDevices'),
      props: true,
      meta: {
        activeMenu: '/devices'
      }
    },
    {
      path: 'hisdata/:sn',
      name: 'HisData',
      component: () => import('@/views/hisdata'),
      props: true,
      meta: {
        activeMenu: '/devices'
      }
    },
    {
      path: 'HisData2/:sn/:deviceType',
      name: 'HisData2',
      component: () => import('@/views/hisdata/index2.vue'),
      props: true,
      meta: {
        activeMenu: '/devices'
      }
    },
    {
      path: '*',
      component: () => import('@/views/404')
    }
  ]
};
